import React from 'react';
import { motion } from 'framer-motion';
import { Camera } from 'lucide-react';

const GallerySection = ({ images }) => {
  const galleryItems = [
    {
      src: images.classroomStudy,
      title: "Suasana Pembelajaran",
      description: "Kelas berpenghawa dingin yang kondusif",
      span: "md:col-span-2 md:row-span-2"
    },
    {
      src: images.studentsPledge,
      title: "Ikrar Pelajar",
      description: "Membentuk sahsiah dan disiplin",
      span: ""
    },
    {
      src: images.staffPhoto,
      title: "Barisan Pendidik",
      description: "Guru-guru berdedikasi dan berkelayakan",
      span: ""
    },
    {
      src: images.studentAssembly,
      title: "Perhimpunan",
      description: "Aktiviti bersama membina ukhuwah",
      span: "md:col-span-2"
    },
  ];

  return (
    <section className="py-32 bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 relative overflow-hidden">
      {/* Decorative blur */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-96 h-96 bg-purple-500 rounded-full filter blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-pink-500 rounded-full filter blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md text-purple-200 rounded-full text-sm font-semibold mb-6 border border-white/20">
            <Camera className="w-4 h-4" />
            Galeri SRII DUAT
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Kehidupan di Sekolah Kami
          </h2>
          <p className="text-xl text-purple-200 max-w-3xl mx-auto">
            Melihat lebih dekat suasana pembelajaran dan aktiviti pelajar SRII DUAT sejak 2015
          </p>
        </motion.div>

        {/* Masonry gallery grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-6xl mx-auto auto-rows-[240px]">
          {galleryItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -8 }}
              className={`group relative rounded-3xl overflow-hidden shadow-2xl cursor-pointer ${item.span}`}
            >
              <img
                src={item.src}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" />
              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="text-xl font-bold text-white mb-1">{item.title}</h3>
                <p className="text-purple-200 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
